import moment from 'moment';

export const CURRENT_MONTH_MARKER_COLOR = '#ECC94B';
const CURRENT_MONTH_MARKER_SIZE = 8;

export const getCurrentMonthDiscreteMarkers = (rows, referenceDate = moment()) => {
  if (!Array.isArray(rows)) {
    return [];
  }

  const reference = moment(referenceDate);

  return rows.reduce((markers, row, dataPointIndex) => {
    if (row?.date && moment(row.date).isSame(reference, 'month')) {
      markers.push({
        seriesIndex: 0,
        dataPointIndex,
        fillColor: CURRENT_MONTH_MARKER_COLOR,
        strokeColor: CURRENT_MONTH_MARKER_COLOR,
        size: CURRENT_MONTH_MARKER_SIZE,
      });
    }
    return markers;
  }, []);
};
